import { OrderLineBlock } from './OrderLineBlock'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

export function OrderLineAdd({ onClick }: { onClick: () => void }) {
  return <OrderLineBlock onClick={onClick} className={'flex justify-center items-center cursor-pointer'}>
    <FontAwesomeIcon className={'m-auto'} icon={faPlus} />
  </OrderLineBlock>
}